const initialState = {
  loading: false
};

export function fetchWheelsExchangeConfig(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_WHEELS_EXCHANGE_CONFIG.SUCCESS':
      return {
        ...state,
        configuration: action.configuration.body,
      };
    case 'FETCH_WHEELS_EXCHANGE_SUMMARY.SUCCESS':
      return {
        ...state,
        days: action.days.body.days,
      };
    default:
      return state
  }
}

export function fetchTiresExchangeConfig(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_TIRES_EXCHANGE_CONFIG.SUCCESS':
      return {
        ...state,
        configuration: action.configuration.body,
      };
    case 'FETCH_TIRES_EXCHANGE_SUMMARY.SUCCESS':
      return {
        ...state,
        days: action.days.body.days,
      };
    default:
      return state
  }
}

export function updateWheelsExchangeConfig(state = initialState, action) {
  switch(action.type) {
    case 'UPDATE_WHEELS_EXCHANGE_CONFIG.SUCCESS':
      return {
        ...state,
        configuration: action.configuration.body,
      };
    default:
      return state;
  }
}

export function updateTiresExchangeConfig(state = initialState, action) {
  switch(action.type) {
    case 'UPDATE_TIRES_EXCHANGE_CONFIG.SUCCESS':
      return {
        ...state,
        configuration: action.configuration.body,
      };
    default:
      return state;
  }
}
